module.exports = __webpack_public_path__ + "static/media/jenniferlopez.c52cd82d.png";